import { useEffect, useState } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { Surface } from '@/components/ui/surface'

const SLOW_AFTER_MS = 20_000

const SECTIONS = ['Wie', 'Gesprek', 'Taken']

/** The wait while Sparky works: skeletons for the three blocks of the review, and honest copy. */
export function ProcessingView({ offline }: { offline: boolean }) {
  const [slow, setSlow] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SLOW_AFTER_MS)
    return () => clearTimeout(timer)
  }, [])
  return (
    <div className="space-y-4" aria-busy="true">
      <p role="status" className="text-base">
        {offline
          ? 'Verbinding verbroken. De verwerking loopt door op de server; we halen het resultaat op zodra je weer online bent.'
          : slow
            ? 'Dit duurt langer dan normaal. Je kunt dit scherm verlaten; de verwerking loopt door.'
            : 'Meestal 5–15 seconden…'}
      </p>
      {SECTIONS.map((section) => (
        <Surface key={section} variant="section" className="space-y-2">
          <p className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">{section}</p>
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-1/2" />
        </Surface>
      ))}
    </div>
  )
}
